export const isProduction = process.env.NODE_ENV === 'production'

export const SITE_URL = isProduction ? 'https://proxyorb.com' : 'http://localhost:3000'

export const GITHUB_USERNAME = 'proxyorb'

export const SITE_NAME = 'ProxyOrb'
export const SITE_KEYWORDS = [
  'free web proxy',
  'site proxy',
  'proxy browser',
  'online proxy',
  'anonymous browsing',
  'unblock websites',
  'video proxy'
]

export const SITE_GITHUB_URL = 'https://github.com/proxyorb'
export const SITE_FACEBOOK_URL = 'https://www.facebook.com/proxyorb'
export const SITE_INSTAGRAM_URL = 'https://www.instagram.com/proxyorb'
export const SITE_X_URL = 'https://x.com/proxyorb'
export const SITE_YOUTUBE_URL = 'https://www.youtube.com/@proxyorb'
